import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../../redux/messages';
import specializationServices from './specialization.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getSpecialization = (params, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_SPECIALIZATION,
      payload: true
    });
    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};

    // const resp = await client.get(iType === 1 ? '/api/app/Formal_Especialidad/' : '/api/app/Funcional_Especialidad/', {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   },
    //   params: data
    // });
    const resp = await specializationServices.getSpecializations(params, iType);
    dispatch({
      type: actions.GET_SPECIALIZATION,
      payload: {
        specialization: resp.data.data,
        specializationLength: resp.data.count,
      }
    });
    dispatch({
      type: actions.SPECIALIZATION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.SPECIALIZATION_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_SPECIALIZATION,
      payload: false
    });
  }
}

export const saveSpecialization = (req, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_SPECIALIZATION,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.post(iType === 1 ? '/api/app/Formal_Especialidad/' : '/api/app/Funcional_Especialidad/', data, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Token ${token}`
    //   }});
    const resp = await specializationServices.saveSpecialization(req, iType);
    const { specialization, specializationLength } = getState().specialization;
    const aSpecialization= [...specialization, resp.data];
    dispatch({
      type: actions.GET_SPECIALIZATION,
      payload: {
        specialization: aSpecialization,
        specializationLength: specializationLength + 1
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_LOADER_SPECIALIZATION,
      payload: false
    });
  }
}

export const editSpecialization = (req, id, index, iType, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_SPECIALIZATION,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // const resp = await client.put(iType === 1 ? `/api/app/Formal_Especialidad/${id}/` : `/api/app/Funcional_Especialidad/${id}/`, data, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    const resp = await specializationServices.editSpecialization(id, req, iType);
    const { specialization, specializationLength } = getState().specialization;
    specialization[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_SPECIALIZATION,
      payload: {
        specialization: specialization,
        specializationLength: specializationLength
      }
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  }finally{
    setShowModal(false)
    dispatch({
      type: actions.SAVE_LOADER_SPECIALIZATION,
      payload: false
    });
  }
}

export const deleteSpecialization = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_SPECIALIZATION,
      payload: true
    });

    // const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    // await client.delete(iType === 1 ? `/api/app/Formal_Especialidad/${id}/` : `/api/app/Funcional_Especialidad/${id}/`, {
    // headers: {
    //   'Content-Type': 'application/json',
    //   'Authorization': `Token ${token}`
    // }});
    await specializationServices.deleteSpecialization(id, iType);
    const { specialization, specializationLength } = getState().specialization;
    specialization.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_SPECIALIZATION,
      payload: {
        specialization: specialization,
        specializationLength: specializationLength -1
      }
    });
    dispatch({
      type: actions.SPECIALIZATION_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    let message = null;
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
        message = ex.response.data.mensaje;
      }else{
        errorManage(ex);
        message = messages.errorMessage;
      }
    }else{
      errorManage(ex);
      message = messages.errorMessage;
    }
    dispatch({
      type: actions.SPECIALIZATION_FAIL,
      payload: message,
    });
  }finally{
    dispatch({
      type: actions.LOADING_SPECIALIZATION,
      payload: false
    });
  }
}
